import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import PrivacyPolicyContent from "./privacyPolicyContent";

const PrivacyPolicy = () => {
    return (
        <Fragment>
            <section className="section bg-home-2 align-items-center">
                <Container>
                    <Row className="align-items-center">
                        <PrivacyPolicyContent />
                    </Row>
                </Container>
            </section>
        </Fragment>
    )
}

export default PrivacyPolicy;